var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0069 23.5859H26.1682C25.2469 23.5859 24.5 24.3328 24.5 25.2541V56.2817C24.5 57.203 25.2469 57.9499 26.1682 57.9499H51.0069C51.9282 57.9499 52.6751 57.203 52.6751 56.2817V25.2541C52.6751 24.3328 51.9282 23.5859 51.0069 23.5859Z",
    fill: "#583BE2",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9342 20.5H32.2228C31.3015 20.5 30.5547 21.2469 30.5547 22.1682V25.004C30.5547 25.9253 31.3015 26.6722 32.2228 26.6722H44.9342C45.8554 26.6722 46.6023 25.9253 46.6023 25.004V22.1682C46.6023 21.2469 45.8554 20.5 44.9342 20.5Z",
    fill: "#583BE2",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5547 35.9629H40.1466",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5547 48.5742H40.1466",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5547 42.2676H45.0509",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5147 30.7091C61.232 31.2262 61.3821 32.2271 60.865 32.9444L54.6928 41.3852L48.8043 49.4257C48.6208 49.6926 48.3539 49.8928 48.0369 49.9929L41.9648 52.6119L42.8656 46.1895C42.8656 45.8726 42.9824 45.5556 43.1659 45.2887L49.0545 37.2482L55.2266 28.8074C55.7438 28.0901 56.7447 27.9399 57.462 28.4571L59.5805 30.0084L60.5147 30.6924V30.7091Z",
    fill: "#583BE2",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8086 30.7266L59.4469 34.8636",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0977 45.3887L48.736 49.5257",
    stroke: "#D6CEFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#7762DF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc_icon.2a9c09a9356b3977d4bccb1a183cc430.svg";
export { ForwardRef as ReactComponent };